(function () {
  function fmt(cents) {
    if (window.theme?.Currency?.formatMoney && window.theme?.shopSettings?.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.shopSettings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // ── Product page: quantity × price summary ──────────────────────────────────
  function getProductPageUnitCents() {
    const el =
      document.querySelector('.price__regular .price-item--regular') ||
      document.querySelector('.price__sale .price-item--sale') ||
      document.querySelector('.price-item--regular');
    if (!el) return null;
    const match = el.textContent.replace(/[^\d.]/g, '');
    const num = parseFloat(match);
    return isNaN(num) ? null : Math.round(num * 100);
  }

  function setupProductQtyInput(input) {
    if (input._dezlinQtyInit) return;
    input._dezlinQtyInit = true;

    const wrap = input.closest('.product-form__quantity');
    if (!wrap) return;

    let summary = wrap.nextElementSibling?.classList?.contains('dezlin-qty-price-summary')
      ? wrap.nextElementSibling
      : null;

    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'dezlin-qty-price-summary';
      wrap.after(summary);
    }

    function update() {
      const qty = parseInt(input.value, 10) || 1;
      if (qty <= 1) {
        summary.style.display = 'none';
        return;
      }
      const unitCents = getProductPageUnitCents();
      if (!unitCents) return;
      summary.style.display = 'block';
      summary.innerHTML = fmt(unitCents) + ' &times; ' + qty + ' = <strong>' + fmt(unitCents * qty) + '</strong>';
    }

    input.addEventListener('change', update);
    input.addEventListener('input', update);
    update();
  }

  function initProductPage() {
    document.querySelectorAll('.product-form .quantity__input').forEach(setupProductQtyInput);

    // Re-check after variant changes update the price display
    document.addEventListener('variant:changed', function () {
      setTimeout(function () {
        document.querySelectorAll('.product-form .quantity__input').forEach(function (inp) {
          inp._dezlinQtyInit = false;
          setupProductQtyInput(inp);
          inp.dispatchEvent(new Event('input'));
        });
      }, 80);
    });
  }

  // ── Collection page: wholesale quantity widget live price ───────────────────
  function initWholesaleCards() {
    document.querySelectorAll('.wq-card-widget').forEach(function (wrap) {
      // Stop all clicks inside the widget from bubbling to the card's ghost link
      wrap.addEventListener('click', function (e) { e.stopPropagation(); });
    });
  }

  // ── Mini-cart: optimistic line price on quantity change ─────────────────────
  function updateMiniCartLine(input) {
    const li = input.closest('li[data-unit-price]');
    if (!li) return;

    const unitCents = parseInt(li.dataset.unitPrice, 10);
    if (!unitCents) return;

    const qty = parseInt(input.value, 10) || 1;

    const summary = li.querySelector('.dezlin-line-summary');
    if (summary) {
      summary.style.display = qty > 1 ? 'block' : 'none';
      const dlsUnit = summary.querySelector('.dls-unit');
      const dlsQty = summary.querySelector('.dls-qty');
      const dlsTotal = summary.querySelector('.dls-total');
      if (dlsUnit) dlsUnit.textContent = fmt(unitCents);
      if (dlsQty) dlsQty.textContent = qty;
      if (dlsTotal) dlsTotal.textContent = fmt(unitCents * qty);
    }

    // Optimistic subtotal — sum all visible line items
    let totalCents = 0;
    document.querySelectorAll('li[data-unit-price]').forEach(function (row) {
      const uc = parseInt(row.dataset.unitPrice, 10) || 0;
      const inp = row.querySelector('.quantity__input');
      const q = inp ? (parseInt(inp.value, 10) || 1) : 1;
      totalCents += uc * q;
    });
    document.querySelectorAll('#mini-cart-subtotal').forEach(function (el) {
      el.textContent = fmt(totalCents);
    });
  }

  function initMiniCartLivePrices() {
    // Event delegation: works even after mini-cart re-renders from API
    document.addEventListener('change', function (e) {
      if (e.target.matches('.quantity__input')) updateMiniCartLine(e.target);
    });
    document.addEventListener('input', function (e) {
      if (e.target.matches('.quantity__input')) updateMiniCartLine(e.target);
    });
  }

  function init() {
    if (document.querySelector('.product-form')) initProductPage();
    if (document.querySelector('.wq-card-widget')) initWholesaleCards();
    initMiniCartLivePrices();

    // Re-init wholesale cards after infinite scroll / pagination loads more products
    document.addEventListener('collection:loaded', initWholesaleCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
